<div class="container_width w-full">
  <div class="w-full flex flex-column gap-3">
    <h1 class="text-left text-3xl font-medium">Add Slot</h1>

      <div class="w-full">
        <p-table
          [value]="tableData" styleClass="p-datatable-gridlines tableCon"
          [tableStyle]="{ 'min-width': '50rem' }">
          <ng-template pTemplate="header">
            <tr>
              <th>Day</th>
              <th>Slot Timing</th>
              <th>Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-dayIndex>
            <tr>
              <td>{{ getDayOfWeek(dayIndex.day) }}</td>
              <td>
                <div class="inline-flex align-items-center justify-content-center gap-2 flex-wrap">
                  <div *ngFor="let timing of dayIndex.availability; let i = index" class="w-auto inline-flex align-items-center gap-1" style="padding: 4px 8px 4px 10px; border-radius: 50px; background-color: #E6E5F3;">
                    <p>{{timing.timezone}}: {{ timing.from }} - {{ timing.to }}</p>
                    <p-button (click)="deleteSingleTimeSlot(dayIndex.day,i)" icon="pi pi-times-circle" styleClass="removeSlot"/>
                  </div>
                </div>
              </td>
              <td><p-button (onClick)="showDialog(allPeerTimings?.applicationUserId??'' , dayIndex.day)" label="Add Slot" icon="pi pi-plus-circle" styleClass="viewapplication"/></td>
            </tr>
          </ng-template>
      </p-table>
      </div>
  </div>
</div>

<p-dialog header="Add Slot" [modal]="true" [(visible)]="visible" [style]="{ width: '35rem' }">
  <form [formGroup]="newTimeSlotForm" (ngSubmit)="saveSlot(selectedDay)">
    <span class="p-text-secondary block mb-3">Enter Slot Timing</span>
    <span styleclass="pop_day" class=" block mb-3">{{getDayOfWeek(selectedDay)}}</span>
    <div class="flex flex-column align-items-start gap-2 mb-3">
      <label for="username" class="font-semibold w-6rem">Time-Zone</label>
      <p-dropdown class="w-full" styleClass="cal_w"
      inputId="calendar-timeonly"
      optionLabel="displayName"
      optionValue="displayName"
      formControlName="timeZone"
      [options]="timeZonesList"
      [showClear]="true"
      [filter]="true" 
      filterBy="displayName"
      [ngClass]="{'ng-invalid ng-dirty' : submitted }"
      placeholder="Select a Time-Zone"/>
    </div>

    <div class="flex flex-column align-items-start gap-2 mb-3">
        <label for="username" class="font-semibold w-6rem">From Time</label>
        <p-calendar class="w-full" styleClass="cal_w"
        inputId="calendar-timeonly"
        formControlName="from"
        [timeOnly]="true"
        hourFormat="12" />
    </div>

    <div class="flex flex-column align-items-start gap-2 mb-4">
        <label for="email" class="font-semibold w-6rem">To Time</label>
        <p-calendar class="w-full" styleClass="cal_w"
        inputId="calendar-timeonly"
        formControlName="to"
        [timeOnly]="true"
        hourFormat="12" />
    </div>

    <div class="flex justify-content-center gap-2">
        <p-button label="Save" type="submit" class="w-full" styleClass="saveBtn"/>
    </div>
  </form>
</p-dialog>